<template>
  <v-form>
    <v-card>
      <v-card-title>
        <h4 center>
          <v-icon>mdi-brightness-percent</v-icon>
          {{ title }}
        </h4>
      </v-card-title>
      <v-card-text>
        <v-text-field
            v-model="name"
            label="Lohnart"
            type="number"
            min="0"
            :error-messages="nameErrors"
            @input="$v.name.$touch()"
            @blur="$v.name.$touch()"
            required
        />
        <v-text-field
            v-model="code"
            label="Bezeichnung"
            :error-messages="codeErrors"
            @input="$v.code.$touch()"
            @blur="$v.code.$touch()"
            required
        />

        <v-checkbox
            label="Anlassbezogene Zulage"
            v-model="fixedAmountOfMinutes"
            hide-details="auto"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on">
              <v-checkbox
                  label="Maximale Stunden pro Woche"
                  v-model="hasMaxHoursPerWeek"
                  v-bind="attrs"
                  hide-details="auto"
              />
            </span>
          </template>
          <span>Wenn Sie dieses Feature aktivieren, werden für diese Lohnart max. die von Ihnen angebene Anzahl an Stunden exportiert.</span>
        </v-tooltip>

        <v-text-field
            v-if="fixedAmountOfMinutes"
            v-model="minutes"
            label="Minuten"
            type="number"
            min="1"
            :error-messages="minutesErrors"
        />
        <v-text-field
            v-if="hasMaxHoursPerWeek"
            v-model="hours"
            label="Stunden"
            type="number"
            min="1"
            :error-messages="hoursErrors"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" text @click="doCancel">Abbrechen</v-btn>
        <v-btn v-if="canBeDeleted" color="error" class="white--text" @click="onDelete">
          <v-icon left dark>mdi-close</v-icon>
          Löschen
        </v-btn>
        <v-btn color="primary" @click="doConfirm" :disabled="!valid">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

import {validationMixin} from 'vuelidate';
import {required, minValue, requiredIf} from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  validations: {
    name: {
      required,
      minValue: minValue(0),
    },
    code: {
      required,
    },
    minutes: {
      required: requiredIf(function () {
        return !!this.fixedAmountOfMinutes;
      })
    },
    hours: {
      requiredIf: requiredIf(function () {
        return this.hasMaxHoursPerWeek;
      })
    }
  },
  name: 'ExtraCharge',
  props: {
    initialData: {
      type: Object,
    },
  },
  computed: {
    title() {
      return this.initialData ? this.name : `Lohnart hinzufügen: ${this.name}`;
    },
    canBeDeleted() {
      return this.initialData && this.initialData.id;
    },
    valid() {
      return !this.$v.$invalid;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) {
        return errors;
      }
      if (!this.$v.name.required) {
        errors.push('Bitte geben Sie eine Nummer ein');
      }
      if (!this.$v.name.minValue) {
        errors.push('Bitte geben Sie eine Nummer ein ');
      }
      return errors;
    },
    codeErrors() {
      const errors = [];
      if (!this.$v.code.$dirty) {
        return errors;
      }
      if (!this.$v.code.required) {
        errors.push('Bitte geben Sie eine Bezeichnung ein');
      }

      return errors;
    },
    minutesErrors() {
      const errors = [];
      if (!this.fixedAmountOfMinutes) {
        return errors;
      }

      if (!this.$v.minutes.$dirty) {
        return errors;
      }
      if (!this.$v.minutes.required) {
        errors.push('Please enter the minutes');
      }

      return errors;
    },
    hoursErrors() {
      if (!this.hasMaxHoursPerWeek || !this.$v.hours.$dirty) {
        return [];
      }

      return !this.$v.hours.valid ? ['Bitte geben Sie die Stunden ein'] : [];
    }
  },
  watch: {
    hasMaxHoursPerWeek(v) {
      if (v && this.fixedAmountOfMinutes) {
        this.fixedAmountOfMinutes = false;
      }
    },
    fixedAmountOfMinutes(v) {
      if (v && this.hasMaxHoursPerWeek) {
        this.hasMaxHoursPerWeek = false;
      }
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete');
    },
    doConfirm() {
      const minutes = this.hasMaxHoursPerWeek ? this.hours * 60 : this.minutes;
      const extraCharge = {
        id: this.initialData ? this.initialData.id : null,
        name: this.name,
        code: this.code,
        fixedAmountOfMinutes: this.fixedAmountOfMinutes,
        hasMaxHoursPerWeek: this.hasMaxHoursPerWeek,
        minutes: minutes,
      };
      this.$emit('confirm', extraCharge);
    },
    doCancel() {
      this.$emit('cancel');
    },
  },
  data() {
    return {
      name: this.initialData ? this.initialData.name : '',
      code: this.initialData ? this.initialData.code : '',
      fixedAmountOfMinutes: this.initialData ? this.initialData.fixedAmountOfMinutes : false,
      hasMaxHoursPerWeek: this.initialData ? this.initialData.hasMaxHoursPerWeek : false,
      minutes: this.initialData ? this.initialData.minutes : 1,
      hours: this.initialData && this.initialData.hasMaxHoursPerWeek ? this.initialData.minutes / 60 : 0,
    };
  },
};
</script>
